import * as ngCore from '@angular/core'
import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'

import type { TypeParams } from '../../types'

import { getActionsConfig } from './actions'
import { Api } from './api'
import * as effects from './effects'
import { Selectors } from './selectors'
import { State } from './state'

/**
 * Makes one set of responsible persons across the selected Space records.
 */
export class Plugin extends ec.plugins.Plugin<
  TypeParams,
  typeof Plugin.id,
  State,
  Selectors,
  ReturnType<typeof getActionsConfig>
> {
  /** @see {@link ec.plugins.Plugin.Id.Custom} */
  public static id = ec.plugins.Plugin.Id.Custom.create(
    'BulkResponsiblePersons',
  )

  /** @see {@link Api} */
  public readonly api = ngCore.inject(Api)

  /** Convenience accessor for the feature's action creators. */
  public get actions(): Plugin['feature']['actions'] {
    return this.feature.actions
  }

  /** Convenience accessor for the feature's selectors. */
  public get selectors(): Plugin['feature']['selectors'] {
    return this.feature.selectors
  }

  constructor({ collection }: Readonly<Plugin.constructor.Params>) {
    super({
      actions: getActionsConfig(),
      collection,
      id: Plugin.id,
      initialState: State.INITIAL,
      selectors: () => new Selectors(this),
    })

    this.feature.registerEffects(
      effects.executeSubmit(this),
      effects.reloadRecordsOnSubmitSuccess(this),
      effects.reloadResponsiblePersonsOnSubmitSuccess(this),
    )
  }
}

export namespace Plugin {
  export namespace constructor {
    export interface Params {
      collection: ec.Collection<TypeParams>
    }
  }
}
